<template>
  <transition name="fadeIn">
    <div class="v-modal" v-if="show">
      <div class="container">
        <div class="content">
          <div v-if="title" class="title bbt1">
            {{ title }}
          </div>
          <div class="scroll">
            <div>
              <div v-html="contentHtml"></div>
              <slot></slot>
            </div>
          </div>
          <div class="btns">
            <i class="close" @click="onBtnClick()"></i>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: {
      default: false
    },
    title: {
      default: ""
    },
    contentHtml: {
      default: ""
    },
    callback: {
      type: Function
    }
  },
  methods: {
    onBtnClick() {
      this.show = false;
      this.callback && this.callback();
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/scss/px2rem.scss";

.v-modal {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: #fff;
  overflow: hidden;
  .container {
    padding: px2rem(260) px2rem(110) px2rem(250);
    position: relative;
    height: 100%;
    width: 100%;
    .content {
      width: 100%;
      height: 100%;
      overflow: hidden;
      .title {
        width: 100%;
        padding-bottom: px2rem(40);
        font-size: px2rem(42);
        line-height: px2rem(42);
        color: #333;
        text-align: center;
      }
      .bbt1 {
        position: relative;
        &::before {
          display: block;
          visibility: visible;
          content: "";
          overflow: auto;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          z-index: 0;
          -webkit-transform-origin: 0 0;
          -ms-transform-origin: 0 0;
          transform-origin: 0 0;
          -webkit-transform: scale(1);
          -ms-transform: scale(1);
          transform: scale(1);
          pointer-events: none;
          -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
          border-bottom: 1px solid #eee;
        }
      }
      .scroll {
        width: 100%;
        height: 100%;
        margin-top: px2rem(40);
        padding-bottom: px2rem(160);
        font-size: px2rem(32);
        line-height: px2rem(56);
        color: #666;
        -webkit-overflow-scrolling: touch;
        overflow-y: auto;
        position: relative;
        z-index: 1;
      }
      .btns {
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 2;
        width: 100%;
        height: px2rem(250);
        line-height: px2rem(250);
        text-align: center;
        background: #fff;
        .close {
          display: inline-block;
          width: px2rem(100);
          height: px2rem(100);
          background-image: url(~@/assets/icon-close.png);
          background-position: 50% 50%;
          background-repeat: no-repeat;
          background-size: px2rem(50) px2rem(50);
        }
      }
    }
  }
}

.fadeIn-enter-active,
.fadeIn-leave-active {
  transition: opacity 0.3s;
}
.fadeIn-enter,
.fadeIn-leave-active {
  opacity: 0;
}
</style>
